import { WheelOfFortuneMode } from '../../redux/games/wheel-of-fortune';
import { Api } from '../api';
import { GamesApi } from '../games-api';

export class WheelOfFortuneApi {
    private static readonly PATH = 'wheel-of-fortune';
    
    constructor(private readonly m_api: Api) {}

    public async getInfo() {
        return this.m_api.get(`${GamesApi.PATH}/${WheelOfFortuneApi.PATH}`);
    }

    public async spin(mode: WheelOfFortuneMode) {
        return this.m_api.post(`${GamesApi.PATH}/${WheelOfFortuneApi.PATH}/spin`, { mode });
    }
}